import { extendObservable } from 'mobx';

class VersionsModel {
    constructor(session) {
        this._session = session;

        extendObservable(this, {
            audiostreamerversion: '',
            backendversion: '',
            frontendversion: '',
            bootloaderversion: '',
            firmwareversion: '',
            icecastversion: '',
            kernelversion: '',
            rootfsversion: '',
            errorNetwork: false
        });
    }

    async load() {
        console.log('VersionModel: start');

        try {
            const settings = await this._session.rpc('call', [
                '',
                'version',
                'get',
                {}
            ]);

            if (settings === 500) {
                Object.assign(this, {
                    errorNetwork: true
                });
            } else {
                const settingobj = {
                    audiostreamerversion: settings[1].versions.audiostreamer,
                    backendversion: settings[1].versions.backend,
                    frontendversion: settings[1].versions.frontend,
                    bootloaderversion: settings[1].versions.bootloader,
                    firmwareversion: settings[1].versions.firmware,
                    icecastversion: settings[1].versions.icecast,
                    kernelversion: settings[1].versions.kernel,
                    rootfsversion: settings[1].versions.rootfs
                };

                Object.assign(this, settingobj);
            }
        } catch (err) {
            console.error('VersionModel:' + err);
        }

        console.log('VersionModel: end');
    }
}

export default VersionsModel;



// WEBPACK FOOTER //
// ./src/models/VersionsModel.js